import React from 'react';
import { kebabCase } from 'lodash';
import PropTypes from 'prop-types';
import { Button, Modal, ModalFooter, ModalHeader } from 'reactstrap';
const actions = {
  default: {
    text: 'Are you sure?',
    confirmButtonText: 'Confirm'
  },
  bulkDelete: {
    text: 'Are you sure you want to delete this record?',
    confirmButtonText: 'Delete'
  },
  bulkDuplicate: {
    text: 'Are you sure you want to duplicate this record?',
    confirmButtonText: 'Duplicate'
  },
  bulkSetContent: {
    text: 'Are you sure you want to update this record?',
    confirmButtonText: 'Update'
  },
  bulkUndelete: {
    text: 'Are you sure you want to restore this record?',
    confirmButtonText: 'Restore'
  }
};
const pluralizeText = originalText => {
  let result = originalText;
  result = result.replace('this record', 'these records');
  return result;
};
const getActionType = selectedAction => {
  if (selectedAction.type === 'bulkDelete') return 'bulkDelete';
  if (selectedAction.type === 'bulkSetContent') return 'bulkSetContent';
  if (selectedAction.type === 'bulkDuplicate') return 'bulkDuplicate';
  if (selectedAction.type === 'bulkUndelete') return 'bulkUndelete';
  return 'default';
};
const CabinetActionModal = ({
  shouldPluralizeText: _shouldPluralizeText = false,
  selectedAction: _selectedAction = null,
  onConfirm,
  onClose
}) => {
  const actionType = getActionType(_selectedAction);
  let {
    text
  } = actions[actionType];
  if (_shouldPluralizeText) {
    text = pluralizeText(text);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    "data-testid": `t-camodal-${kebabCase(actionType)}`,
    isOpen: Boolean(_selectedAction),
    toggle: onClose,
    style: {
      position: 'absolute',
      top: '20%',
      left: '55%',
      transform: 'translate(-50%, -20%)',
      minWidth: '600px'
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, null, text), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    "data-testid": `t-camodal-confirm-button-${kebabCase(actionType)}`,
    onClick: onConfirm
  }, actions[actionType].confirmButtonText)));
};
CabinetActionModal.propTypes = {
  selectedAction: PropTypes.shape({
    type: PropTypes.string
  }),
  shouldPluralizeText: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};
export default CabinetActionModal;